import React from 'react';
import PropTypes from 'prop-types';
import { Box, HStack, Text, Flex, Link as CLink, VStack, Hide, useBreakpointValue } from '@chakra-ui/react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import LogoSmall from '../../../assets/LogoSmall';
import Book from '../../../assets/Book';
import Cloud from '../../../assets/Cloud';
import UserPlus from '../../../assets/UserPlus';
import Motarboard from '../../../assets/Motarboard';
import AuthenticatedLayout from '../AuthenticatedLayout';
import HeaderButtons from '../HeaderButtons';
import '@fontsource/rubik-beastly';
import '@fontsource/news-cycle';

const AppHeader = ({ isAuthenticated, userRole, userRoles }) => {
  const showIcon = useBreakpointValue({ base: false, md: true, xl: false });
  return (
    <VStack width={'100%'}>
      <Flex
        height="44px"
        bgColor="#11284B"
        w={'100%'}
        justifyContent={{ base: 'center', ['lg']: 'space-between' }}
        px={5}
        zIndex={99}
      >
        <HStack spacing={2}>
          <HeaderButtons
            iconChildren={<LogoSmall fill={'currentColor'} width={'24px'} />}
            label={'RadonAway'}
            link={'https://www.radonaway.com/'}
          />
          <CLink _focus={{ boxShadow: 'none ' }} href="https://radstarcrm.com/" _hover={{ textDecoration: 'none' }}>
            <HStack px={5} variant="ghost" height={'44px'} color={'#11284B'} fontSize={'13px'} bgColor={'#fff'}>
              <Box hidden={showIcon}>
                <Cloud fill={'currentColor'} />
              </Box>
              <Hide below="md">
                <Text fontWeight={500}>Radon Management Cloud</Text>
              </Hide>
            </HStack>
          </CLink>
          <HeaderButtons
            iconChildren={<Book fill={'currentColor'} />}
            label={'Knowledge Base'}
            link={'http://radstaralpha.com/'}
          />
          <HeaderButtons
            iconChildren={<Motarboard fill={'currentColor'} />}
            label={'Training'}
            link={'https://radonaway.com/radon-training'}
          />
          <HeaderButtons
            iconChildren={<UserPlus fill={'currentColor'} />}
            label={'Become a Customer'}
            link={'https://www.radonaway.com/new-radonaway-cust'}
          />
        </HStack>
        <Hide below="lg">
          <Flex>
            <CLink
              px={4}
              bgColor={'#AA1F2E'}
              display={'flex'}
              alignItems={'center'}
              color={'#fff'}
              _focus={{ boxShadow: 'none ' }}
              href="https://www.radon.com/what-is-radon"
              _hover={{ bg: '#871925', color: '#fff', textDecoration: 'none' }}
            >
              <Text
                textTransform={'uppercase'}
                fontWeight={700}
                letterSpacing={'1px'}
                fontSize={20}
                fontFamily={`'News Cycle', sans-serif`}
              >
                What is{' '}
                <Text
                  as={'span'}
                  fontFamily={`'Rubik Beastly', sans-serif`}
                  fontWeight={400}
                  letterSpacing={'1px'}
                  fontSize={22}
                >
                  Radon
                </Text>
                ?{/* <Image src="/what-is-radon.png" /> */}
              </Text>
            </CLink>
            <CLink _focus={{ boxShadow: 'none ' }} href="tel://800-767-3703" _hover={{ textDecoration: 'none' }}>
              <HStack
                px={5}
                variant="ghost"
                height={'44px'}
                color={'#fff'}
                fontSize={'14px'}
                _hover={{ bg: '#fff', color: '#11284B', boxShadow: 'none ' }}
                _focus={{ boxShadow: 'none ' }}
              >
                <Text color={'currentColor'} fontWeight={'700'} fontSize={'20px'} lineHeight={'20px'}>
                  (800) 767-3703
                </Text>
              </HStack>
            </CLink>
          </Flex>
        </Hide>
      </Flex>
      {isAuthenticated && <AuthenticatedLayout userRole={userRole} userRoles={userRoles} />}
    </VStack>
  );
};

const mapStateToProps = ({ profile }) => ({
  userRole: profile.role,
  userRoles: profile.roles,
});

AppHeader.propTypes = {
  isAuthenticated: PropTypes.bool,
  userRole: PropTypes.string,
  userRoles: PropTypes.array,
};

export default withRouter(connect(mapStateToProps)(AppHeader));



// WEBPACK FOOTER //
// src/components/layout/AppHeader/index.jsx